import React from 'react';
import SharedWorkerProvider from './SharedWorkerProvider';
export default function EnabledSharedWorkerProvider({ hasSharedWorkers, ...props }) {
    if (hasSharedWorkers) {
        return React.createElement(SharedWorkerProvider, { ...props });
    }
    return React.createElement(React.Fragment, null, props.children);
}
